module.exports = __webpack_public_path__ + "img/banner-bg-5.0f9e0de7.png";